import React from 'react';

import Placeholder from 'components/consumer/Placeholder';

const PDPProductDescriptionPlaceholder = () => (
  <div className="flex flex-col items-start space-y-5 mt-14 pt-14 border-t border-solid border-gray-light6">
    <Placeholder type="rect" loading className="!w-full !h-[64px]" />
    <Placeholder type="text" loading rows={4} className="!w-full" />
    <Placeholder type="rect" loading className="!w-[178px] !h-[26px]" />
  </div>
);

export default PDPProductDescriptionPlaceholder;
